const store = {
  namespaced: true,
  state: {
    dialog: false
  },
  getters: {},
  mutations: {
    setDialog(state, data) {
      state.dialog = data;
    }
  },
  actions: {
    async queryCustomerCouponList({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/store/queryCustomerCouponList", params);
      return data;
    },
    async distributeCoupons({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/distribution/distributeCoupons", params);
      return data;
    },
    async queryBrandList({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/queryBrandList", params);
      return data;
    },
    async queryCustomers({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/distribution/queryCustomers", params);
      return data;
    },
    async getDetail({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/getDetail", params);
      return data;
    },
    async disable({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/disable", params);
      return data;
    },
    // 指定服务无门槛优惠券
    async serviceUnconditional({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/save/serviceUnconditional", params);
      return data;
    },
    // 指定商品满金额优惠券
    async productReachedAmount({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/save/productReachedAmount", params);
      return data;
    },
    // 指定商品无门槛优惠券
    async productUnconditional({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/save/productUnconditional", params);
      return data;
    },
    // 订单满减优惠券
    async orderReachedAmount({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/save/orderReachedAmount", params);
      return data;
    },
    // 订单无门槛优惠券
    async orderUnconditional({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/save/orderUnconditional", params);
      return data;
    },
    async queryList({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/queryList", params);
      return data;
    },
    async queryServiceItemList({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/queryServiceItemList", params);
      return data;
    },
    async createPayment({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/addCardTemplate", params);
      return data;
    },
    async queryOpCouponList({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/activity/queryTemplateList", params);
      return data;
    }
  }
};

export default store;
